module.exports = __webpack_public_path__ + "static/media/g.b019dd40.png";